// extracted by mini-css-extract-plugin
module.exports = {"main":"Search_main__MJcCo","input":"Search_input__oJpUP"};